<div class="toast-stack" aria-live="polite">
  @for (toast of toastService.messages(); track toast.id) {
    <article class="toast" [class.toast-error]="toast.variant === 'destructive'">
      <div>
        <h3>{{ toast.title }}</h3>
        @if (toast.description) {
          <p>{{ toast.description }}</p>
        }
      </div>
      <button type="button" (click)="toastService.dismiss(toast.id)" aria-label="Dismiss">x</button>
    </article>
  }
</div>
